import React from "react";

import "./style.scss";

const Header = ({ companyData }) => {
  return (
    <div className="header">
      {companyData?.logo?.thumbnails?.normal?.src && (
        <img
          src={companyData?.logo?.thumbnails?.normal?.src}
          alt="Logo"
          className="logo"
        />
      )}

      <h1 className="title">{companyData?.name}</h1>
      <div className="description">{companyData?.short_description}</div>
      <p className="description">
        Bizning ish vaqtimiz: <span>{companyData?.working_times}</span>
      </p>
      <div className="divider" />
    </div>
  );
};

export default Header;
